import { itx } from "../../../src/translationItx/itx";
import parquet1 from "./floorImages/parquet-1.png";
import parquet2 from "./floorImages/parquet-2.png";
import tiles1 from "./floorImages/tiles-1.png";
import tiles2 from "./floorImages/tiles-2.png";
import paving1 from "./floorImages/paving-1.png";
import paving2 from "./floorImages/paving-2.png";
import terrace from "./floorImages/terrace.png";
import grass from "./floorImages/grass.png";
import parquet1Pdf from "./floorImages/pdf/parquet-1.jpg";
import parquet2Pdf from "./floorImages/pdf/parquet-2.jpg";
import tiles1Pdf from "./floorImages/pdf/tiles-1.jpg";
import tiles2Pdf from "./floorImages/pdf/tiles-2.jpg";
import paving1Pdf from "./floorImages/pdf/paving-1.jpg";
import paving2Pdf from "./floorImages/pdf/paving-2.jpg";
import terracePdf from "./floorImages/pdf/terrace.jpg";
import grassPdf from "./floorImages/pdf/grass.jpg";
import { C1_FloorFinish, type C1_FloorFinish as C1_FloorFinishType } from "../types/C1_ModelTypes";

export const C1_FLOOR_FINISH_OPTIONS: ReadonlyArray<{ value: C1_FloorFinishType; label: string }> = [
  { value: C1_FloorFinish.None, get label() { return itx("c1.ui.Keiner", "Keiner"); } },
  { value: C1_FloorFinish.General1, get label() { return itx("c1.ui.Allgemein_1", "Allgemein 1"); } },
  { value: C1_FloorFinish.General2, get label() { return itx("c1.ui.Allgemein_2", "Allgemein 2"); } },
  { value: C1_FloorFinish.Parquet1, get label() { return itx("c1.ui.Parkett_1", "Parkett 1"); } },
  { value: C1_FloorFinish.Parquet2, get label() { return itx("c1.ui.Parkett_2", "Parkett 2"); } },
  { value: C1_FloorFinish.Tiles1, get label() { return itx("c1.ui.Fliesen_1", "Fliesen 1"); } },
  { value: C1_FloorFinish.Tiles2, get label() { return itx("c1.ui.Fliesen_2", "Fliesen 2"); } },
  { value: C1_FloorFinish.Paving1, get label() { return itx("c1.ui.Pflaster_1", "Pflaster 1"); } },
  { value: C1_FloorFinish.Paving2, get label() { return itx("c1.ui.Pflaster_2", "Pflaster 2"); } },
  { value: C1_FloorFinish.Terrace, get label() { return itx("c1.ui.Terrassenbelag", "Terrassenbelag"); } },
  { value: C1_FloorFinish.Grass, get label() { return itx("c1.ui.Rasen", "Rasen"); } },
];

export const C1_FLOOR_FINISH_IMAGES: Partial<Record<C1_FloorFinishType, string>> = {
  [C1_FloorFinish.Parquet1]: parquet1,
  [C1_FloorFinish.Parquet2]: parquet2,
  [C1_FloorFinish.Tiles1]: tiles1,
  [C1_FloorFinish.Tiles2]: tiles2,
  [C1_FloorFinish.Paving1]: paving1,
  [C1_FloorFinish.Paving2]: paving2,
  [C1_FloorFinish.Terrace]: terrace,
  [C1_FloorFinish.Grass]: grass,
};

/** Dedicated 512 px JPEG textures keep printed floor patterns compact. */
export const C1_PDF_FLOOR_FINISH_IMAGES = new Map<string, string>([
  [parquet1, parquet1Pdf],
  [parquet2, parquet2Pdf],
  [tiles1, tiles1Pdf],
  [tiles2, tiles2Pdf],
  [paving1, paving1Pdf],
  [paving2, paving2Pdf],
  [terrace, terracePdf],
  [grass, grassPdf],
]);
